export const USER_ID = 'user-id'
export const AUTH_TOKEN = 'token'
export const GROUPS = 'groups'

export const states = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RO',
  'RS',
  'RR',
  'SC',
  'SE',
  'SP',
  'TO'
]

export const daysPayment = [
  { label: 'Dia 10', value: 10 },
  { label: 'Dia 20', value: 20 },
  { label: 'Dia 30', value: 30 }
]
